<template>
  <div class="resources-page">
    <div class="page-header">
      <h1>低空资源中心</h1>
      <p class="page-subtitle">汇聚优质低空经济资源，助力行业发展</p>
    </div>

    <div class="action-bar">
      <button class="btn-primary" @click="showAddModal = true">
        + 加入资源
      </button>
    </div>

    <div class="tab-bar">
      <button 
        v-for="tab in tabs" 
        :key="tab.id"
        :class="['tab-btn', { active: activeTab === tab.id }]"
        @click="filterByTab(tab.id)"
      >
        {{ tab.label }}
      </button>
    </div>

    <!-- Desktop Table -->
    <div class="resources-table-wrapper desktop-only">
      <table class="resources-table">
        <thead>
          <tr>
            <th>资源名称</th>
            <th>描述</th>
            <th>公司</th>
            <th>联系人</th>
            <th>电话</th>
            <th>地点</th>
            <th>标签</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="resource in filteredResources" :key="resource.id">
            <td class="resource-title">{{ resource.title }}</td>
            <td class="resource-desc">{{ resource.description }}</td>
            <td>{{ resource.company }}</td>
            <td>{{ resource.nickname }}</td>
            <td>{{ resource.phone }}</td>
            <td>{{ resource.location }}</td>
            <td>
              <span 
                v-for="(tag, index) in resource.tags" 
                :key="index" 
                class="table-tag"
              >
                {{ tag }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Mobile Cards -->
    <div class="mobile-cards mobile-only">
      <div 
        v-for="resource in filteredResources" 
        :key="resource.id" 
        class="mobile-card"
      >
        <div class="mobile-card-header">
          <h4 class="mobile-card-title">{{ resource.title }}</h4>
          <span 
            v-for="(tag, index) in resource.tags.slice(0, 2)" 
            :key="index" 
            class="mobile-card-tag"
          >
            {{ tag }}
          </span>
        </div>
        <p class="mobile-card-desc">{{ resource.description }}</p>
        <div class="mobile-card-info">
          <div class="mobile-info-item" v-if="resource.company">
            <span class="mobile-info-label">公司</span>
            <span class="mobile-info-value">{{ resource.company }}</span>
          </div>
          <div class="mobile-info-item" v-if="resource.nickname">
            <span class="mobile-info-label">联系人</span>
            <span class="mobile-info-value">{{ resource.nickname }}</span>
          </div>
          <div class="mobile-info-item" v-if="resource.phone">
            <span class="mobile-info-label">电话</span>
            <span class="mobile-info-value">{{ resource.phone }}</span>
          </div>
          <div class="mobile-info-item" v-if="resource.location">
            <span class="mobile-info-label">地点</span>
            <span class="mobile-info-value">{{ resource.location }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="page-footer" v-if="filteredResources.length > 0">
      <p>共 {{ filteredResources.length }} 个资源</p>
    </div>

    <AddResourceModal 
      v-if="showAddModal" 
      @close="showAddModal = false"
      @submit="handleAddResource"
    />
  </div>
</template>

<script>
import AddResourceModal from '@/components/AddResourceModal.vue'
import { lowAltitudeResources } from '@/data/resources.js'
import axios from 'axios'

export default {
  name: 'ResourcesView',
  components: {
    AddResourceModal
  },
  data() {
    return {
      resources: lowAltitudeResources,
      activeTab: 'all',
      showAddModal: false,
      tabs: [
        { id: 'all', label: '全部' }
      ]
    }
  },
  computed: {
    filteredResources() {
      if (this.activeTab === 'all') {
        return this.resources
      }
      return this.resources.filter(resource => 
        resource.tags.includes(this.activeTab)
      )
    }
  },
  mounted() {
    this.fetchLabels()
  },
  methods: {
    async fetchLabels() {
      try {
        const response = await axios.get('https://moodsci.com/Backend/lable/getLable')
        if (response.data && Array.isArray(response.data)) {
          const labelTabs = response.data.map(item => ({
            id: item.bqname,
            label: item.bqname
          }))
          this.tabs = [...this.tabs, ...labelTabs]
        }
      } catch (error) {
        console.error('获取标签失败:', error)
      }
    },
    filterByTab(tabId) {
      this.activeTab = tabId
    },
    handleAddResource(newResource) {
      this.resources.unshift(newResource)
      this.showAddModal = false
    }
  }
}
</script>

<style scoped>
.resources-page {
  min-height: 100vh;
  background: #f5f7fa;
  padding: 20px;
}

.page-header {
  text-align: center;
  margin-bottom: 32px;
  padding: 40px 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 16px;
  color: #fff;
}

.page-header h1 {
  margin: 0 0 12px 0;
  font-size: 32px;
  font-weight: 700;
}

.page-subtitle {
  margin: 0;
  font-size: 16px;
  opacity: 0.9;
}

.action-bar {
  text-align: center;
  margin-bottom: 32px;
}

.btn-primary {
  background: linear-gradient(135deg, #42b983 0%, #35495e 100%);
  color: #fff;
  border: none;
  padding: 12px 32px;
  border-radius: 24px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(66, 185, 131, 0.3);
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(66, 185, 131, 0.4);
}

.tab-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
  margin-bottom: 32px;
}

.tab-btn {
  padding: 6px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 20px;
  background: #fff;
  color: #666;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.tab-btn:hover {
  border-color: #42b983;
  color: #42b983;
}

.tab-btn.active {
  background: linear-gradient(135deg, #42b983 0%, #35495e 100%);
  border-color: #42b983;
  color: #fff;
}

.resources-table-wrapper {
  max-width: 1200px;
  margin: 0 auto;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow-x: auto;
}

.resources-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.resources-table th,
.resources-table td {
  padding: 12px 16px;
  text-align: left;
  border-bottom: 1px solid #e8e8e8;
}

.resources-table th {
  background: #f8f9fa;
  font-weight: 600;
  color: #333;
  white-space: nowrap;
}

.resources-table tbody tr:hover {
  background: #f5f7fa;
}

.resources-table tbody tr:last-child td {
  border-bottom: none;
}

.resource-title {
  font-weight: 500;
  color: #333;
  white-space: nowrap;
}

.resource-desc {
  max-width: 200px;
  color: #666;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.table-tag {
  display: inline-block;
  padding: 2px 8px;
  margin: 2px;
  background: #e6f7ff;
  color: #1890ff;
  border-radius: 4px;
  font-size: 12px;
}

.mobile-only {
  display: none;
}

.page-footer {
  text-align: center;
  padding: 24px;
  color: #666;
  font-size: 14px;
}

@media (max-width: 768px) {
  .resources-page {
    padding: 16px;
  }

  .page-header {
    padding: 30px 16px;
    margin-bottom: 24px;
  }

  .page-header h1 {
    font-size: 24px;
  }

  .page-subtitle {
    font-size: 14px;
  }

  .btn-primary {
    padding: 10px 24px;
    font-size: 14px;
  }

  .tab-btn {
    padding: 6px 14px;
    font-size: 12px;
  }

  .desktop-only {
    display: none;
  }

  .mobile-only {
    display: block;
  }

  .mobile-cards {
    max-width: 100%;
    margin: 0 auto;
  }

  .mobile-card {
    background: #fff;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }

  .mobile-card-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
    flex-wrap: wrap;
  }

  .mobile-card-title {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin: 0;
  }

  .mobile-card-tag {
    display: inline-block;
    padding: 2px 8px;
    background: #e6f7ff;
    color: #1890ff;
    border-radius: 4px;
    font-size: 11px;
  }

  .mobile-card-desc {
    font-size: 13px;
    color: #666;
    margin: 0 0 12px 0;
    line-height: 1.5;
  }

  .mobile-card-info {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
  }

  .mobile-info-item {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .mobile-info-label {
    font-size: 11px;
    color: #999;
  }

  .mobile-info-value {
    font-size: 13px;
    color: #333;
    word-break: break-all;
  }
}
</style>
